import React, { Component } from "react";
import { Card, CardBody, UncontrolledAlert } from "reactstrap";
import DataTable from "../Shared/DataTable";
import { MdModeEdit } from "react-icons/md";

export class WaterSettingTable extends Component {
    render() {
        const columns = [
            {
                Header: "Current Hydration Value",
                accessor: "dailyHydrationTarget",
                Cell: (row) => <span>{`${row.value}`} Litre(s)</span>,
                style: {
                    textAlign: "center",
                },
            },
        ];

        const { match, fetching, data, error, filterData, selectRow, pages, page, pageSize, viewFoodsLibrary, setPageNumber, setPageSize } = this.props;

        return (
            <div>
                <Card className="pp4">
                    <CardBody>
                        {error && <UncontrolledAlert color="danger">{error.message}</UncontrolledAlert>}
                     
                        <DataTable
                            columns={columns}
                            loading={fetching}
                            manual={true}
                            pages={pages}
                            page={page}
                            pageSize={pageSize}
                            urlParams={match}
                            data={data ? data : []}
                            count={data ? data.length : 0}
                            defaultPageSize={3}
                          
                            selectRow={selectRow}
                            filterData={filterData}
                            setPageNumber={setPageNumber}
                            setPageSize={setPageSize}
                            searchParam="searchKey"
                            //actions={actions}
                            hideSearchParam={true}
                            hideActions={true}
                            dontShowPagination={true}
                        />
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default WaterSettingTable;
